import ClinicalNoteWritingCategoriesList from "./Categories";
import ClinicalNoteWritingTopicsList from "./Topics";

export const containers = {
  ClinicalNoteWritingCategoriesList,
  ClinicalNoteWritingTopicsList,
};



// WEBPACK FOOTER //
// ./src/modules/clinicalNoteWriting/containers/index.js